module.exports = __webpack_public_path__ + "img/10.93f35b78.webp";